import { render } from "./SportView.vue?vue&type=template&id=f8fb3d32&scoped=true"
import script from "./SportView.vue?vue&type=script&lang=js"
export * from "./SportView.vue?vue&type=script&lang=js"

import "./SportView.vue?vue&type=style&index=0&id=f8fb3d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8fb3d32"]])

export default __exports__